<template>
  <div id="app">
    <router-view />
    <page-loader />
  </div>
</template>
<script>
import axios from "axios";
import PageLoader from "./components/Voya/PageLoader.vue";

export default {
  components: {
    PageLoader
  },
  beforeCreate() {

    function isIOS(){
      const ua = window.navigator.userAgent;
          const isIOS = /iPad|iPhone|iPod/.test(ua);
          const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
          const isWebView = isIOS && !isSafari && /AppleWebKit/.test(ua);
          return isWebView;
    }
    function isAndroid(){
      if(window.androidApp)
        return true;
      return false;
    }
    function getDeviceToken() {
      if(isIOS()){
        let payload = { methodName: "getDeviceToken"}
        return prompt(JSON.stringify(payload));
      }else if (isAndroid()){
        return window.androidApp.getDeviceToken();
      }
      return;
    }
    function registerDeviceToken() {
      try {
        var deviceToken = getDeviceToken();
        if(deviceToken && this.$root.$data.login.User){
          axios.post("/user/RegisterMobilDevice", {
            deviceToken: deviceToken
          });
        }
      }catch(e){
        console.log("registerDeviceToken error", e)
      }
      
    }
    function saveBaseUrl() {
      try {
        if(isIOS()){
          let payload = { methodName: "saveBaseUrl", baseUrl: window.location.origin}
          return prompt(JSON.stringify(payload));
        }else if (isAndroid()){
          return window.androidApp.saveBaseUrl(window.location.origin);
        }
      }catch(e){
        console.log("saveBaseUrl error", e)
      }
      
    }
    var user = window.localStorage.getItem("user");

    if (user) {
      user = JSON.parse(user);
      console.log("Oturumu açık kullanıcı: ", user);
      this.$root.$data.login = user;
      
  
      this.$store.commit("setUser", user);
      axios.defaults.headers.common["token"] = user.Key;
      axios.defaults.headers.common["account"] = this.$route.params.accountCode;
      const currentPath = this.$route.path;
      registerDeviceToken();
      saveBaseUrl();
      if (currentPath === "/" || currentPath === "/index") {
        this.$router.push("/index");
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    
  }
};
</script>
<style></style>
